export default {
  homework: {
    title: 'Praca domowa',
    content: 'Tu możesz zobaczyć szczegóły pracy domowej oraz załączniki i przesłać gotową pracę domową lektorowi, jeżeli o to poprosił, w formie elektronicznej. Plik trafi od razu do skrzynki mailowej lektora.',
    btn: 'Rozumiem',
  },
  homeworks_step1: {
    title: 'Nadchodzące zajęcia',
    content: 'Tu sprawdzisz datę i miejsce nadchodzących zajęć.',
    content2: 'W przypadku zajęć prowadzonych zdalnie, kliknij w ',
    content3: 'dołącz do spotkania',
    content4: ', aby dołączyć do lekcji.',
    btn: 'Dalej',
  },
  homeworks_step2: {
    title: 'Prace domowe',
    content: 'Tu zobaczysz jaka była zadana praca domowa. Możesz też sprawdzić czy została odrobiona.',
    content2: 'Oznaczenia',
    content3: 'prac domowych:',
    btn: 'Rozumiem',
    btn_rev: 'Wstecz',
  },
  attendances_step1: {
    title: 'Nadchodzące zajęcia',
    content: 'Tu sprawdzisz datę i miejsce nadchodzących zajęć',
    content2: 'W przypadku zajęć prowadzonych zdalnie, kliknij w ',
    content3: 'dołącz do spotkania',
    content4: ', aby dołączyć do lekcji.',
    btn: 'Dalej',
  },
  attendances_step2: {
    title: 'Obecności',
    content: 'Tu możesz zobaczyć frekwencję dziecka. Aby dowiedzieć się, co było realizowane na zajęciach, kliknij  “Pokaż tematy”.',
    content2: 'Oznaczenia',
    content3: 'obecności:',
    btn: 'Rozumiem',
    btn_rev: 'Wstecz',
  },
  grades: {
    title: 'Oceny',
    content: 'Tu zobaczysz oceny Twojego dziecka - ich kategorie oraz za co zostały wystawione. Jeżeli miejsce na ocenę jest puste, oznacza to, że uczeń był nieobecny.',
    btn: 'Rozumiem',
  },
};
